<template>
    <div>
        <el-dialog title="重发电子签章" :visible.sync="dialogVisible" width="500px" @close="$emit('close')">
            <el-form :model="resendForm" label-width="120px">
                <el-form-item label="联系人姓名：">
                    <el-input v-model="resendForm.name" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系人手机：">
                    <el-input v-model="resendForm.mobile" placeholder="请输入联系人手机" maxlength="11"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmResend" :disabled="!resendForm.name || !resendForm.mobile">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean, // 新增visible prop接收父组件状态
        result: Object
    },
    data() {
        return {
            dialogVisible: this.visible,
            resendForm: {
                name: this.result.Orders_ESignName || '',
                mobile: this.result.Orders_EsignMobile || '',
            }
        };
    },
    watch: {
        visible(newVal) {
            this.dialogVisible = newVal; // 监听父组件状态变化
        }
    },
    methods: {
        async confirmResend() {
            try {
                const params = {
                    orders_id: this.result.Orders_ID,
                    json: JSON.stringify({ "Orders_ESignName": this.resendForm.name, "Orders_EsignMobile": this.resendForm.mobile})
                };
                let loadingInstance = this.$loading(); // 显示 loading
                const response = await this.$newsApi.contract.SPCOrdersResendContract(params);
                this.$closeLoading(loadingInstance); // 关闭 loading
                if (response.data.Resultcode === 0) {
                    this.$message.success('电子签章重发成功');
                    this.dialogVisible = false;
                    this.$emit('refresh', this.result.Orders_ID);
                } 
            } catch (error) {
                console.error('重发电子签章失败:', error);
                this.$message.error('操作失败，请稍后重试');
            }
        }
    }
};
</script>
